import React from 'react';
import { Typography, Result } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
var {
  Text
} = Typography;
export default function LoadingContainer() {
  return /*#__PURE__*/React.createElement("div", {
    className: ""
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignContent: 'center'
    }
  }), /*#__PURE__*/React.createElement(Result, {
    icon: /*#__PURE__*/React.createElement(LoadingOutlined, null),
    title: "Hang Tight, we are fetching your data...",
    extra: /*#__PURE__*/React.createElement(Text, null, "This should only take a few moments...")
  })));
}